import { createSelector } from 'reselect';

import { orderingSettingsSelector } from 'redux/modules/general';

export const dineInEnabledSelector = createSelector(
  orderingSettingsSelector,
  ({ dineInEnabled }) => Boolean(dineInEnabled),
);
